export const PAGINATION_DEFAULT_VALUES = [5, 10, 15, 25, 50]

export const XLSX_FORMAT = ".xlsx"
